import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicWalletConfirm({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.8.84a.72.72 0 01.65-.39h8.2a.75.75 0 01.63 1.16l-2.1 3.24.61.39a.75.75 0 01-.82 1.26c-.25-.17-.54-.35-.87-.55H5.8c-2.68 1.44-3.85 3.2-3.85 5.24 0 .51.23 1 .84 1.43.62.45 1.63.81 3.09.97a.75.75 0 11-.16 1.49 8 8 0 01-3.8-1.24A3.22 3.22 0 01.44 11.2c0-2.71 1.58-4.85 4.42-6.44L2.82 1.61A.75.75 0 012.8.84zm3.64 3.61h2.22l.08-.16 1.53-2.34H4.83l1.53 2.34.08.16zM11.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.21-5.14a.65.65 0 01.92 0l.9.9L12.9 10a.65.65 0 11.92.92l-2.23 2.23a.65.65 0 01-.92 0L9.3 11.78a.65.65 0 010-.91z"
      />
    </svg>
  );
}

SvgBasicWalletConfirm.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicWalletConfirm.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicWalletConfirm svgRef={ref} {...props} />
));
export default ForwardRef;
